import Swal from 'sweetalert2';

// Configuración personalizada de SweetAlert2
const customSwal = Swal.mixin({
  background: 'linear-gradient(135deg, #0f0f23 0%, #1a1a2e 100%)',
  color: '#f1f5f9',
  confirmButtonColor: '#00c6fb',
  cancelButtonColor: '#6b7280',
  backdrop: `
    rgba(0, 0, 0, 0.7)
    url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%2300c6fb' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")
  `,
  customClass: {
    popup: 'custom-swal-popup',
    title: 'custom-swal-title',
    content: 'custom-swal-content',
    confirmButton: 'custom-swal-confirm-btn',
    cancelButton: 'custom-swal-cancel-btn',
    icon: 'custom-swal-icon'
  },
  buttonsStyling: false,
  showClass: {
    popup: 'animate__animated animate__fadeInDown'
  },
  hideClass: {
    popup: 'animate__animated animate__fadeOutUp'
  }
});

// Agregar estilos personalizados
const style = document.createElement('style');
style.textContent = `
  .custom-swal-popup {
    border: 1px solid rgba(0, 198, 251, 0.3) !important;
    border-radius: 20px !important;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3) !important;
  }

  .custom-swal-title {
    color: #f1f5f9 !important;
    font-size: 1.5rem !important;
    font-weight: 600 !important;
  }

  .custom-swal-content {
    color: #94a3b8 !important;
    font-size: 1rem !important;
  }

  .custom-swal-confirm-btn {
    background: linear-gradient(135deg, #00c6fb 0%, #005bea 100%) !important;
    color: white !important;
    border: none !important;
    border-radius: 12px !important;
    padding: 12px 24px !important;
    font-weight: 600 !important;
    font-size: 0.875rem !important;
    text-transform: uppercase !important;
    letter-spacing: 0.5px !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    box-shadow: 0 4px 15px rgba(0, 198, 251, 0.3) !important;
  }

  .custom-swal-confirm-btn:hover {
    transform: translateY(-2px) !important;
    box-shadow: 0 8px 25px rgba(0, 198, 251, 0.4) !important;
  }

  .custom-swal-cancel-btn {
    background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%) !important;
    color: white !important;
    border: none !important;
    border-radius: 12px !important;
    padding: 12px 24px !important;
    font-weight: 600 !important;
    font-size: 0.875rem !important;
    text-transform: uppercase !important;
    letter-spacing: 0.5px !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    box-shadow: 0 4px 15px rgba(107, 114, 128, 0.3) !important;
  }

  .custom-swal-cancel-btn:hover {
    transform: translateY(-2px) !important;
    box-shadow: 0 8px 25px rgba(107, 114, 128, 0.4) !important;
  }

  .custom-swal-icon {
    font-size: 3rem !important;
  }

  .swal2-actions {
    gap: 1.5rem !important;
    margin-top: 2rem !important;
    justify-content: center !important;
  }

  .swal2-actions .swal2-confirm {
    order: 1 !important;
    margin-right: 0.5rem !important;
  }

  .swal2-actions .swal2-cancel {
    order: 2 !important;
    margin-left: 0.5rem !important;
  }

  .swal2-icon.swal2-success {
    border-color: #10b981 !important;
  }

  .swal2-icon.swal2-success [class^='swal2-success-line'] {
    background-color: #10b981 !important;
  }

  .swal2-icon.swal2-error {
    border-color: #ef4444 !important;
  }

  .swal2-icon.swal2-error [class^='swal2-x-mark-line'] {
    background-color: #ef4444 !important;
  }

  .swal2-icon.swal2-warning {
    border-color: #f59e0b !important;
  }

  .swal2-icon.swal2-warning [class^='swal2-warning-line'] {
    background-color: #f59e0b !important;
  }

  .swal2-icon.swal2-info {
    border-color: #3b82f6 !important;
  }

  .swal2-icon.swal2-info [class^='swal2-info-line'] {
    background-color: #3b82f6 !important;
  }

  .swal2-icon.swal2-question {
    border-color: #3b82f6 !important;
  }

  .swal2-icon.swal2-question [class^='swal2-question-line'] {
    background-color: #3b82f6 !important;
  }

  @media (max-width: 768px) {
    .custom-swal-popup {
      margin: 1rem !important;
    }
    
      .custom-swal-confirm-btn,
  .custom-swal-cancel-btn {
    width: 100% !important;
    margin: 0.5rem 0 !important;
  }
  
  .swal2-actions {
    gap: 1rem !important;
    margin-top: 1.5rem !important;
  }
  
  .swal2-actions .swal2-confirm {
    order: 1 !important;
  }
  
  .swal2-actions .swal2-cancel {
    order: 2 !important;
  }
  }
`;

document.head.appendChild(style);

// Servicio de alertas usando SweetAlert2
class AlertService {
  // Métodos de conveniencia
  success(title, text, options = {}) {
    return customSwal.fire({
      icon: 'success',
      title,
      text,
      ...options
    });
  }

  error(title, text, options = {}) {
    return customSwal.fire({
      icon: 'error',
      title,
      text,
      ...options
    });
  }

  warning(title, text, options = {}) {
    return customSwal.fire({
      icon: 'warning',
      title,
      text,
      ...options
    });
  }

  info(title, text, options = {}) {
    return customSwal.fire({
      icon: 'info',
      title,
      text,
      ...options
    });
  }

  question(title, text, options = {}) {
    return customSwal.fire({
      icon: 'question',
      title,
      text,
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
      ...options
    });
  }

  confirm(title, text, options = {}) {
    return customSwal.fire({
      icon: 'question',
      title,
      text,
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
      ...options
    });
  }

  // Método fire genérico para casos especiales
  fire(options) {
    return customSwal.fire(options);
  }
}

// Instancia global
const alertService = new AlertService();

export default alertService; 